import { render, staticRenderFns } from "./SingleUser.vue?vue&type=template&id=0d24aba4&"
import script from "./SingleUser.vue?vue&type=script&lang=js&"
export * from "./SingleUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports